import api from "./client";

import type { ApiResponse, BaseFilterParams, Paginated } from "#/types/api";
import type { CreateProductPayload, Product } from "#/types/products";
import type { ScanStatus } from "#/types/sites";

export const productApi = {
  getAll: (
    params?: BaseFilterParams
  ): Promise<ApiResponse<Paginated<Product[]>>> =>
    api.get("/product", { params: params }),
  getStatuses: (id: number): Promise<ApiResponse<ScanStatus[]>> =>
    api.get(`/product/${id}/statuses`),
  getById: (id: number): Promise<ApiResponse<Product>> =>
    api.get(`/product/${id}`),
  create: (body: CreateProductPayload): Promise<ApiResponse<Product>> =>
    api.post("/product", body),
  update: (
    id: number,
    body: Partial<CreateProductPayload>
  ): Promise<ApiResponse<Product>> => api.patch(`/product/${id}`, body),
  bulkDelete: (
    productIds: number[]
  ): Promise<ApiResponse<{ deleted: number }>> =>
    api.post("/product/bulk-delete", { product_ids: productIds }),
  uploadCsvFile: (
    file: File,
    onProgress?: (progress: number) => void,
  ): Promise<
    ApiResponse<{
      success: Product[];
      errors: { row: number; data: Record<string, string>; error: string }[];
    }>
  > =>
    api.uploadFile<
      ApiResponse<{
        success: Product[];
        errors: { row: number; data: Record<string, string>; error: string }[];
      }>
    >("/product/csv/import", file, "file", onProgress),
};
